import { render, staticRenderFns } from "./ResizableContent.vue?vue&type=template&id=3f584f31"
import script from "./ResizableContent.vue?vue&type=script&lang=js"
export * from "./ResizableContent.vue?vue&type=script&lang=js"
import style0 from "./ResizableContent.vue?vue&type=style&index=0&id=3f584f31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports